export default "__VITE_ASSET__DU$QX9t___"